import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminVouchers, adminCreateVoucher, adminDeleteVoucher } from "@/lib/api";

const VouchersAdmin = () => {
  const [list, setList] = useState([]);
  const [code, setCode] = useState("");
  const [percent, setPercent] = useState(10);
  const load = async () => setList(await adminVouchers());
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!code.trim()) return;
    try { await adminCreateVoucher({ code: code.trim(), percent: parseInt(percent, 10) || 0, active: true }); setCode(""); await load(); toast.success("Cod salvat"); }
    catch { toast.error("Eroare"); }
  };
  const remove = async (c) => { await adminDeleteVoucher(c); await load(); };

  return (
    <div className="p-5 sm:p-8" data-testid="vouchers-admin">
      <h2 className="mb-6 text-xl uc font-semibold">Coduri reducere</h2>
      <div className="mb-6 flex flex-wrap items-end gap-2">
        <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="COD" data-testid="voucher-code"
          className="border border-border px-3 py-2 font-mono text-sm uppercase focus:outline-none" />
        <input type="number" value={percent} onChange={(e) => setPercent(e.target.value)} placeholder="%" className="w-20 border border-border px-3 py-2 font-mono text-sm focus:outline-none" />
        <button onClick={create} data-testid="voucher-create" className="bg-foreground px-5 py-2 font-mono text-[11px] uppercase tracking-widest text-white hover:opacity-85">Adaugă</button>
      </div>
      <div className="divide-y divide-border border-y border-border">
        {list.map((v) => (
          <div key={v.code} className="flex items-center justify-between py-3" data-testid={`voucher-${v.code}`}>
            <span className="font-mono text-sm uppercase tracking-widest">{v.code} · -{v.percent}%</span>
            <button onClick={() => remove(v.code)} className="font-mono text-[11px] uppercase tracking-widest text-destructive hover:opacity-60">Șterge</button>
          </div>
        ))}
        {list.length === 0 && <p className="py-4 font-mono text-xs uppercase tracking-widest text-muted-foreground">Niciun cod.</p>}
      </div>
    </div>
  );
};

export default VouchersAdmin;
